import { get, reduce } from 'lodash';

const surveillanceInitialValues = (state) => {
  const hasSurveillance = get(state, 'space.data.surveillance_info.has_surveillance', '');
  const description = get(state, 'space.data.surveillance_info.description', '');

  return {
    has_surveillance: hasSurveillance.toString(),
    surveillance_description: description
  };
};

export default surveillanceInitialValues;
